import { render, staticRenderFns } from "./CarrerasList.vue?vue&type=template&id=ba74799e&scoped=true&"
import script from "./CarrerasList.vue?vue&type=script&lang=js&"
export * from "./CarrerasList.vue?vue&type=script&lang=js&"
import style0 from "./CarrerasList.vue?vue&type=style&index=0&id=ba74799e&lang=scss&scoped=true&"
import style1 from "./CarrerasList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba74799e",
  null
  
)

export default component.exports